<template>
    <modal @close="$emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Discontinue Plan</h3>
        </template>

        <slot>
            <p>
                Every enrollment in <strong>{{ clientPlan.accrual_plan.name }}</strong> ends on this date, and each
                employee's remaining balance is forfeited. This cannot be undone.
            </p>
            <p v-if="clientPlan.enrolled_count">
                {{ clientPlan.enrolled_count }} {{ clientPlan.enrolled_count == 1 ? 'employee is' : 'employees are' }} enrolled.
            </p>

            <form class="mui-form" @submit.prevent="onSubmit()">
                <form-input v-model="formData.end_date" :errors="errors.end_date" type="date" label="Last Day of the Plan" />
            </form>
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">Cancel</button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">Discontinue</button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    props: ['client', 'clientPlan', ],
    mixins: [FormMixin, ModalMixin],
    emits: ['close', 'updated', ],
    data() {
        return {
            formData: {
                end_date: '',
            },
        }
    },
    methods: {
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            return this.$api.post(`/clients/${this.client.id}/settings/accrual-plans/${this.clientPlan.id}/discontinue`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        },
    },
}
</script>
